import { GSC_SCOPE, getGscOAuthClientId, getGscOAuthRedirectUri } from "../config/gscEnv";

const GOOGLE_AUTH_BASE_URL = "https://accounts.google.com/o/oauth2/v2/auth";

/**
 * Build the Google consent URL for a Search Console connection.
 *
 * `state` must come from createOAuthState("gsc") so the callback can verify it.
 *
 * No `include_granted_scopes` here on purpose: it makes Google merge every scope this
 * OAuth client was previously granted for the account into this request, and some
 * combinations are rejected outright with "This request contains scopes that cannot be
 * requested together" (see the same warning in youtubeAuthentication.ts). Search
 * Console runs on its own client precisely so this request stays a single clean scope.
 *
 * `prompt=consent` with `access_type=offline` is what guarantees a refresh token comes
 * back; without it Google returns one only on a user's first ever grant, and the
 * backend rejects the exchange.
 */
export function getGscAuthUrl(state: string): string {
  const clientId = getGscOAuthClientId();
  if (!clientId) {
    throw new Error("Google Search Console client ID is not configured");
  }

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: getGscOAuthRedirectUri(),
    response_type: "code",
    access_type: "offline",
    prompt: "consent",
    scope: GSC_SCOPE,
    state,
  });
  return `${GOOGLE_AUTH_BASE_URL}?${params.toString()}`;
}
